var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.938 17.227"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31472",
    d: "M3.93 17.227h7.086a1.713 1.713 0 001.781-1.695l.578-11.664h1.11a.449.449 0 00.453-.453.455.455 0 00-.453-.461h-3.68V1.691A1.616 1.616 0 008.993.004H5.938a1.61 1.61 0 00-1.8 1.688v1.266H.458a.465.465 0 00-.453.461.459.459 0 00.453.453h1.125l.574 11.66a1.7 1.7 0 001.773 1.695zM5.086 1.735a.81.81 0 01.9-.836h2.96a.806.806 0 01.9.836v1.219h-4.76zM4.008 16.313a.907.907 0 01-.906-.883L2.524 3.868h9.875l-.555 11.562a.909.909 0 01-.914.883zm1.133-1.508a.353.353 0 00.383-.367l-.255-8.647a.359.359 0 00-.383-.359.359.359 0 00-.391.367l.258 8.641a.363.363 0 00.388.365zm2.336 0a.359.359 0 00.392-.367V5.797a.359.359 0 00-.391-.367.366.366 0 00-.4.367v8.641a.366.366 0 00.399.367zm2.328.008a.368.368 0 00.391-.367l.258-8.641a.361.361 0 00-.391-.375.359.359 0 00-.383.359l-.258 8.649a.355.355 0 00.383.375z",
    fill: "inherit"
  })));
}

export default SvgRemove;